import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ProjectsService } from "../../../../../services/projects/projects.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ErrorHandlerService } from "../../../../../services/shared/error-handler.service";
import { FineSettingsService } from "../fine-settings.service";

@Component({
  selector: "app-add-fine",
  templateUrl: "./add-fine.component.html",
  styleUrls: ["./add-fine.component.css"],
})
export class AddFineComponent implements OnInit {
  // Flags
  isLoading = false;

  id;

  form_data = {
    project_id: null,
    rule_name: "",
    rule_description: "",
    first_time_amount: 0,
    first_time_text: "",
    second_time_amount: 0,
    second_time_text: "",
    third_time_amount: 0,
    third_time_text: "",
    fourth_time_amount: 0,
    fourth_time_text: "",
    fifth_time_amount: 0,
    fifth_time_text: "",
    sixth_time_amount: 0,
    sixth_time_text: "",
  };

  projects_select = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private projectService: ProjectsService,
    private fineSettingsService: FineSettingsService,
    private slimLoadingBarService: SlimLoadingBarService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params.id) {
        this.id = params.id;
        this.getFineData();
      }
    });

    this.getAllProjects();
  }

  getFineData() {
    this.fineSettingsService.getFine(this.id).subscribe(
      (res: any) => {
        this.form_data = {
          project_id: res.project_id,
          rule_name: res.rule_name,
          rule_description: res.rule_description,
          first_time_amount: res.first_time_amount,
          first_time_text: res.first_time_text,
          second_time_amount: res.second_time_amount,
          second_time_text: res.second_time_text,
          third_time_amount: res.third_time_amount,
          third_time_text: res.third_time_text,
          fourth_time_amount: res.fourth_time_amount,
          fourth_time_text: res.fourth_time_text,
          fifth_time_amount: res.fifth_time_amount,
          fifth_time_text: res.fifth_time_text,
          sixth_time_amount: res.sixth_time_amount,
          sixth_time_text: res.sixth_time_text,
        };

        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getAllProjects() {
    this.projectService.getProjects(true).subscribe(
      (res: any) => {
        this.projects_select = res.data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  onSave() {
    const payload: any = Object.assign({}, this.form_data);
    if (this.id) {
      payload.id = this.id;
    }

    this.isLoading = true;
    this.fineSettingsService
      .addFine(payload)
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          this.router.navigate([
            "/",
            "pages",
            "financial",
            "settings",
            "fines",
          ]);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      )
      .add(() => {
        this.isLoading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/financial-settings/components/fines/add-fine/add-fine.component.ts